export const earningsCopy = {
  fr: {
    title: "Mes gains",
    description: "Trois étapes vous séparent de votre premier paiement.",
    requestPayout: "Demander un paiement",
    stepLabel: "Étape {n}",
    done: "Terminé",
    current: "En cours",
    locked: "À venir",
    step1Title: "{threshold} contributions validées",
    step1Remaining: "Encore {remaining} à faire valider.",
    step1Pending: "{count} en attente de validation.",
    step1Done: "Seuil atteint.",
    contribute: "Contribuer",
    step2Title: "Test de qualification",
    step2Locked: "Disponible dès que le seuil est atteint.",
    step2Todo: "Un court test d'enregistrement et de traduction, corrigé par un modérateur.",
    step2Review: "Votre test est en cours de correction.",
    step2Done: "Test validé.",
    takeTest: "Passer le test",
    viewTest: "Voir mon test",
    step3Title: "Recevoir vos gains",
    step3Locked: "{rate} F CFA par contribution validée après le test.",
    step3Earning: "{rate} F CFA par contribution validée. Vos gains apparaissent ici.",
    step3Pending: "Demande de {amount} en cours de traitement.",
    viewRequests: "Suivre ma demande",
    figuresTitle: "Vos chiffres",
    validated: "Contributions validées",
    pending: "En attente de validation",
    available: "Gains disponibles",
    requested: "Demandé, en cours",
    beforeTitle: "Avant de demander un paiement",
    beforeId: "Une pièce d'identité valide.",
    beforeTransfer: "Votre numéro Mobile Money ou vos coordonnées bancaires, dans votre profil.",
    beforeQuality: "Un taux d'acceptation d'au moins 80 % sur vos tâches.",
    completeProfile: "Compléter mon profil",
    help: "Une question sur un paiement ?",
    contact: "Écrire au support",
  },
  en: {
    title: "My earnings",
    description: "Three steps to your first payout.",
    requestPayout: "Request a payout",
    stepLabel: "Step {n}",
    done: "Done",
    current: "In progress",
    locked: "Coming next",
    step1Title: "{threshold} validated contributions",
    step1Remaining: "{remaining} more to get validated.",
    step1Pending: "{count} waiting for validation.",
    step1Done: "Threshold reached.",
    contribute: "Contribute",
    step2Title: "Qualification test",
    step2Locked: "Available once the threshold is reached.",
    step2Todo: "A short recording and translation test, corrected by a moderator.",
    step2Review: "Your test is being corrected.",
    step2Done: "Test approved.",
    takeTest: "Take the test",
    viewTest: "View my test",
    step3Title: "Get paid",
    step3Locked: "{rate} F CFA per contribution validated after the test.",
    step3Earning: "{rate} F CFA per validated contribution. Your earnings show here.",
    step3Pending: "A request of {amount} is being processed.",
    viewRequests: "Track my request",
    figuresTitle: "Your figures",
    validated: "Validated contributions",
    pending: "Waiting for validation",
    available: "Available earnings",
    requested: "Requested, in progress",
    beforeTitle: "Before requesting a payout",
    beforeId: "A valid ID document.",
    beforeTransfer: "Your Mobile Money number or bank details, in your profile.",
    beforeQuality: "An acceptance rate of at least 80% on your tasks.",
    completeProfile: "Complete my profile",
    help: "A question about a payout?",
    contact: "Email support",
  },
} as const;

export type EarningsCopy = { [K in keyof (typeof earningsCopy)["fr"]]: string };
